import { useAuth } from "../contexts/AuthContext";
import { ShieldOff } from "lucide-react";

export function ModuleRoute({ module, children }) {
  const { hasModule } = useAuth();

  if (!hasModule(module)) {
    return (
      <div className="text-center py-16" data-testid="module-access-denied">
        <ShieldOff className="w-16 h-16 text-slate-300 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-slate-900 mb-4">Access Denied</h2>
        <p className="text-slate-600">You don't have permission to access this module. Contact an administrator.</p>
      </div>
    );
  }

  return children;
}
